export default [
  '#72147e',
  '#f21170',
  '#fa9905',
  '#ff5200',
  '#eeb76b',
  '#e2703a',
  '#9c3d54',
  '#310b0b',
]